import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { environment } from '../../environments/environment';
import { from, lastValueFrom } from 'rxjs';

const addBearerToken = async (req: HttpRequest<any>, next: HttpHandlerFn): Promise<HttpEvent<any>> => {
  const angularFireAuth = inject(AngularFireAuth);
  let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
  try {
    const firebaseUser = await angularFireAuth.currentUser;
    const token = await firebaseUser?.getIdToken();
    if (token) {
      headers = { ...headers, Authorization: `Bearer ${token}` };
    }
  } catch (error) {
    console.error('Error retrieving token:', error);
  }
  req = req.clone({
    url: environment.apiUrl.concat(req.url),
    setHeaders: headers,
  });
  return lastValueFrom(next(req));
};

export const bearerTokenInterceptor: HttpInterceptorFn = (req, next) => {
  return from(addBearerToken(req, next));
};
